<template>
  <div class="progress-wrapper" :style="wrapStyle">
    <!-- <div
      class="progress"
      @mousedown="mousedownHandler"
      @mouseover="mouseoverHandler"
      @mousemove="mousemoveHandler"
      @mouseup="mouseupHandler"
      :style="pBarStyle"
    >-->

    <div class="progress" :style="pBarStyle">
      <div class="progressBorder">
        <div class="progressBg" :style="progressBorder">
          
        </div>
      </div>
      <div class="ball" :style="ballStyle">{{percent}}%</div>
    </div>
    <!-- <div class="percentValue">
      <span class="span">完成度：</span>
      {{percent}}%
    </div> -->
  </div>
</template>

<script>
export default {
  name: "ProgressBar",
  props: { 
    leftBg: String,
    bgc: String,
    ballBgc: String,
    height: String,
    width: String,
    percent: {
      type: Number,
      default: 10
    }
  },
  data: function() {
    return {
      wrapStyle: {
        width: this.width
      },
      pBarStyle: {
        backgroundColor: this.bgc,
        height: this.height,
        // width: this.percent*0.86*0.9 + "%",
      },
      progressBorder: {
        width: this.percent + "%",
        background: this.leftBg,
        height: this.height,
        
      },
      ballStyle: {
        // borderRadius: parseInt(this.height) / 2 + "px",
        // right: -parseInt(this.height) / 2 + "px"
        // left:this.percent*0.86 + "%"
        // left:this.percent*0.86 + "%",
      },
      // 标记是否按下鼠标
      isMouseDownOnBall: false,
      // 鼠标进body时是否是mousedown
      isMouseDownOnBody: false,
      // 鼠标离开进度条时的clientX
      outProgressClientX: 0,
      // 主要用于防止一个页面内有多个本组件，MouseMove时互相影响而设置的字段
      isCurrentProgress: false
    };
  },
  computed: {
    progressElement() {
      return this.$el.getElementsByClassName("progress")[0];
    }
  },
  methods: {
    mousedownHandler(e) {
      if (e.which === 1) {
        this.isMouseDownOnBall = true;
        this.isCurrentProgress = true;
      }
    },
    mousemoveHandler(e) {
      if (this.isMouseDownOnBall && this.isCurrentProgress) {
        let decimal =
          (e.clientX - this.$el.offsetLeft) / this.progressElement.clientWidth;
        let percent = decimal * 100;
        this.leftStyle.width = percent + "%";
        this.$emit("pbar-drag", percent);
      }
    },
    mouseupHandler(e) {
      if (this.isMouseDownOnBall && this.isCurrentProgress) {
        let decimal =
          (e.clientX - this.$el.offsetLeft) / this.progressElement.clientWidth;
        let percent = decimal * 100;
        this.leftStyle.width = percent + "%";
        this.$emit("pbar-seek", percent);

        this.isMouseDownOnBall = false;
        this.isCurrentProgress = false;
      }
    },
    mouseoverHandler(e) {
      // 没有按左键进入进度条
      if (e.which === 0) {
        this.isMouseDownOnBall = false;
      }
    },
    mouseoutHandler(e) {
      if (e.which === 1 && this.isCurrentProgress) {
        this.outProgressClientX = e.clientX;
        this.isMouseDownOnBody = true;
        this.bodyEventHandler();
      }
    },
    // body元素的事件监听器
    bodyEventHandler() {
      let body = document.getElementsByTagName("body")[0];
      body.addEventListener("mousemove", this.bodyMousemoveHandler);
      body.addEventListener("mouseup", e => {
        this.isMouseDownOnBall = false;
        this.isMouseDownOnBody = false;
        this.outProgressClientX = 0;
        this.isCurrentProgress = false;
        body.removeEventListener("mousemove", this.bodyMousemoveHandler);
      });
    },
    // body元素的mousemove事件监听器
    bodyMousemoveHandler(e) {
      e.preventDefault();
      if (e.which === 1 && this.isMouseDownOnBody === true) {
        let offsetX = e.clientX - this.outProgressClientX;
        // 右移了
        if (offsetX > 0) {
          // 在进度条右边界内
          if (
            e.clientX <
            this.progressElement.clientWidth + this.$el.offsetLeft
          ) {
            let decimal =
              (e.clientX - this.$el.offsetLeft) /
              this.progressElement.clientWidth;
            let percent = decimal * 100;
            this.leftStyle.width = percent + "%";
            this.$emit("pbar-drag", percent);
            // 超出右边界
          } else {
            this.leftStyle.width = "100%";
            this.$emit("pbar-drag", 100);
          }
          // 左移了
        } else if (offsetX < 0) {
          // 在进度条左边界内
          if (e.clientX > this.$el.offsetLeft) {
            let decimal =
              (e.clientX - this.$el.offsetLeft) /
              this.progressElement.clientWidth;
            let percent = decimal * 100;
            this.leftStyle.width = percent + "%";
            this.$emit("pbar-drag", percent);
            // 超出左边界
          } else {
            this.leftStyle.width = "0%";
            this.$emit("pbar-drag", 0);
          }
        }
      }
    }
  },
  watch: {
    percent(cur, old) {
      // console.log(cur)
      this.progressBorder.width = cur + "%";
      // this.ballStyle.left = cur*0.86 + "%";
    }
  }
};
</script>

<style  scoped lang="stylus">

.percentValue {
  text-align: center;
  color: #e1161b;
  margin-top: 10px;
  font-weight: bold;
}
.percentValue span {
  color: #333;
  font-weight: bold;
}
.progress {
  width: 80%;
  margin: 0 0 0 10%;
  height: 15px;
  background-color: #fff;
  cursor: pointer;
  padding: 1px;
  position: relative;
}
.progressBorder {
  border: 1px solid #e1161b;
  border-radius: 15px;
  height: 100%;
  width: 86%;
  background-color: #fff;
  position: relative;
  padding:1px
  .progressBg{
    background-color: #e1161b;
    width :100%;
    height :100%;
    border-radius: 15px;
  }
}

.ball {
  width: 20px;
  top: 1px;
  left :86%;
  padding-left:4px;
  text-align: left;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  position: absolute;
  color: #e1161b;
  font-style:italic;
  height: 18px;
  line-height: 20px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 15px;
}
</style>